/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/gasstation.png'

function RetailFuelNode({ data, isConnectable }) {
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Retail</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Right} />
    </div>
  )
}

export default RetailFuelNode
